import Client from "./Client";
// import RequestList from "./RequestList";

const FaxesService = {
    url: 'admin/connectors',
    getDefault(){
        return {
            id : undefined,
            user_id : undefined,
            reseller_id : undefined,
            caption : undefined,
            code : undefined,
            total_registered_user : undefined,
            last_registered_at : undefined,
            total_paid_user : undefined,
            last_paid_at : undefined,
            created_at : undefined,
            updated_at : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async create(model) {
        return await Client.post(`${this.url}`, model);
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async update(model) {
        return await Client.post(`${this.url}/${model.id}`, model);
    }
}

export default FaxesService